export const holdbackSF = {
    normal: 2.0,
    emergency: 1.25,
};

export const holdbackData = [
    {
        model: 'BS30',
        torque: 30,      // kg-m
        weight: 2.1,            // kg
    },
    {
        model: 'BS50',
        torque: 80,
        weight: 4.0,
    },
    {
        model: 'BS65',
        torque: 160,
        weight: 11.5,
    },
    {
        model: 'BS75',
        torque: 250,
        weight: 13.1,
    },
    {
        model: 'BS85',
        torque: 600,
        weight: 24.7,
    },
    {
        model: 'BS95',
        torque: 800,
        weight: 29.4,
    },
    {
        model: 'BS110',
        torque: 1100,
        weight: 34.2,
    },
    {
        model: 'BS135',
        torque: 1600,
        weight: 68.0,
    },
    {
        model: 'BS160',
        torque: 2500,
        weight: 85.6,
    },
    {
        model: 'BS200',
        torque: 3800,
        weight: 140.0,
    },
    {
        model: 'BS220',
        torque: 5000,
        weight: 263.5,
    },
    {
        model: 'BS250',
        torque: 9000,
        weight: 580.0,
    },
    {
        model: 'BS270',
        torque: 12500,
        weight: 620.0,
    },
    {
        model: 'BS300',
        torque: 18000,
        weight: 850.0,
    },
    {
        model: 'BS335',
        torque: 27000,
        weight: 1379,         // 보간
    },
    {
        model: 'BS350',
        torque: 32000,
        weight: 1605,
    },
    {
        model: 'BS425',
        torque: 52000,
        weight: 2735,       // 보간
    },
    {
        model: 'BS450',
        torque: 70000,
        weight: 3112,       // 보간
    }
];

export const selectBackstop = (value) => {
    if (isNaN(value)) return null;

    const selected = holdbackData.find(obj => obj.torque >= Number(value));

    if (!selected) {    // 없으면 가장 큰 값 전달
        return {
            model: 'BS450',
            torque: 70000,
            weight: 3112,
        };
    }

    return selected;
}
